import axios from "axios";

import { useMutation, useQuery } from "@tanstack/react-query";


const ARCHEM_URL = process.env.REACT_APP_API_URL + "maintenance/";
export const keysChangePassword = {
  all: [{ scope: 'user.roles' }],
  getPasswordSettings: () => [{ ...keysChangePassword.all[0], entity: 'password.settings' }],

}


export const useGetPasswordSettings = () => {

  const getData = async () => {
    const { data } = await axios.get(ARCHEM_URL + 'getpasswordsettings');
    return data;
  }

  return useQuery(keysChangePassword.getPasswordSettings(), getData);
}

export const useSaveUsersNewPassword = () => {
  return useMutation(params => axios.post(`${ARCHEM_URL}savenewpassword`, params));
}


export const useSaveNewPasswordSettings = () => {
  return useMutation(params => axios.post(`${ARCHEM_URL}savepasswordsettings`, params));
}



// export function GetPasswordSettings() {
//   return axios.get(URL + 'getpasswordsettings');
// }

// export function SaveNewPassword(data) {
//   return axios.post(URL + 'savenewpassword', { data })
// }

// export function SavePasswordSettings(data) {
//   return axios.post(URL + 'savepasswordsettings', { data });
// }